import React, { useEffect, useState } from "react";
import {
  Form,
  HyperLink,
  notification,
} from "../../components/Elements/appUtils";
import PageHeader from "../../components/Elements/pageHeader";
import { useDispatch } from "react-redux";
import { GetEachFormFields } from "../../components/_utils/formUtils";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import { singleSaleCategoryFxn, updateSaleCategoryFxn } from "./actions";
import { yesNo } from "../../components/_utils/appUtils";

const EditSaleCategory = (props) => {
  let dispatch = useDispatch();
  let navigate = useNavigate();
  const [salecategoryId, setSaleCategoryId] = useState("");
  useEffect(() => {
    checkcategoryId();
  }, []);

  let id;

  const checkcategoryId = async () => {
    let searchParams = new URLSearchParams(window.location.search);
    id = searchParams.get("_id");
    if (id) {
      getSingleSaleCategory(id);
      setSaleCategoryId(id);
    }
  };
  const getSingleSaleCategory = async (id) => {
    let { data, success } = await dispatch(singleSaleCategoryFxn(id));
    if (success) {
      setTimeout(() => {
        props.form.setFieldsValue({
          name: data.name,
          includeBalance: data.includeBalance,
        });
      }, 300);
    }
  };

  const handleSubmit = (e) => {
    const { form } = props;
    e.preventDefault();

    form.validateFields(async (err, valData) => {
      if (!err) {
        valData._id = salecategoryId;

        let x = await dispatch(updateSaleCategoryFxn(valData));
        if (x && x.success) {
          navigate("/sale-category");
        }
      } else {
        if (err.name) {
          notification.warning({
            message: `Please enter Sale Category Name`,
          });
          return;
        }

        notification.warning({
          message: "Fill All Required Fields",
        });
      }
    });
  };

  let inputTypes = {
    fields: [
      {
        title: "Sale Category Name",
        dataIndex: "name",
        key: "name",
      },
      {
        key: "includeBalance",
        label: "Include Balance",
        span: "col-md-3",
        placeholder: "Choose One",
        type: "select",
        options: yesNo,
        showSearch: true,
        keyAccessor: (x) => x.value,
        valueAccessor: (x) => `${x.name}`,
        onChange: (x) => {
          props.form.setFieldsValue({
            includeBalance: x,
          });
        },
      },
    ],
  };

  return (
    <>
      <PageHeader title={"Edit Sale Category"}>
        <div className="card">
          <div className="card-body">
            <Form onSubmit={handleSubmit}>
              <div className="form-elements-wrapper">
                <div className={"row"}>
                  {inputTypes.fields.map((item, key) => {
                    return !item.hidden ? (
                      <div
                        className={`pb-3 ${item.span ? item.span : "col-md-6"}`}
                        key={key}
                      >
                        <GetEachFormFields {...props.form} item={item} />
                      </div>
                    ) : null;
                  })}
                </div>
              </div>
              <button type="submit" className="btn btn-gradient-primary">
                Submit
              </button>
              <HyperLink
                className=" ms-4 btn btn-danger"
                link={"/sale-category"}
              >
                Cancel
              </HyperLink>
            </Form>
          </div>
        </div>
      </PageHeader>
    </>
  );
};

export default Form.create()(EditSaleCategory);
